import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../AppAuthContext';
import PopUp from '../../GeneralComponents/PopUp';

/*
This component renders a pop up that is being displayed when there is a unsaved page and user tries to go out of build apps page.
It asks the user to save - dont save or cancel exit.
*/
const BuildUpsExitPopUpWindow = (props) => {
  const {
    openAlert,
    setOpenAlert,
    aboutToLogout,
    savedPageClicked,
    aboutToViewPageDataModel,
    setAboutToViewPageDataModel,
    aboutToViewProjectDataModel,
    setAboutToViewProjectDataModel,
    aboutToViewPageFlow,
    setAboutToViewPageFlow,
    aboutToViewProjectFlow,
    setAboutToViewProjectFlow,
    aboutToViewFrontQuality,
    setAboutToViewFrontQuality,
    aboutToViewServerQuality,
    setAboutToViewServerQuality
  } = props;
  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);


  const navigateToPage = () => {

    if (aboutToLogout === false) {
      // Go to view page data model page.
      if (aboutToViewPageDataModel === true) {
        setAboutToViewPageDataModel(false);
        navigate('/view_page_data_model');
      }
      // Go to view project data model page.
      else if (aboutToViewProjectDataModel === true) {
        setAboutToViewProjectDataModel(false);
        navigate('/view_project_data_model');
      }
      // Go to view page flow
      else if (aboutToViewPageFlow === true) {
        setAboutToViewPageFlow(false);
        navigate('/view_page_flow');
      }
      // Go to view project flow
      else if (aboutToViewProjectFlow === true) {
        setAboutToViewProjectFlow(false);
        navigate('/view_project_flow');
      }
      //  Go to view front end project quality
      else if (aboutToViewFrontQuality === true){
        setAboutToViewFrontQuality(false);
        navigate('/front_project_quality',{ state: { reason: 'front' } });
      }
      //  Go to view server project quality 
      else if(aboutToViewServerQuality === true){
        setAboutToViewServerQuality(false);
        navigate('/server_project_quality', { state: { reason: 'server' } });
      }
      // Go to home page
      else {
        navigate('/');
      }
    }
    // Log out
    else {
      dispatch({
        type: 'LOGOUT'
      });
    }

  } 

  // This function fires when users clicks dont save.It navigates to another page without saving
  const handleDontSave = () => {
    navigateToPage();  
  };

  // This functions saves the page is save is needed and then go out of build apps
  const handleSave = () => {
    savedPageClicked();
    navigateToPage();
  };

  return (
      <PopUp
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        handleCancel={handleDontSave}
        handleConfirm={handleSave}
        title="Do you want to save the project ?"
        insideDescription="There are some unsaved pages in the project"
        confirmText='Save'
        cancelText='Do not save'
        cause="SaveBeforeLeave"
      />
  );
};

export default BuildUpsExitPopUpWindow;
